import classNames from "classnames";
import { DetailedHTMLProps, Dispatch, forwardRef, SelectHTMLAttributes, SetStateAction } from "react";

import IconChevronDown from "@/icons/icon-chevron-down";
import IconUneditable from "@/icons/icon-uneditable";
import Icon from "~/components/common/icon";

import styles from "./select.module.scss";

type SelectProps = DetailedHTMLProps<SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement> & {
  id: string;
  options: Array<{ value: string | number; label: string }>;
  onClearErrors?: () => void;
  setInputFocus?: Dispatch<SetStateAction<boolean>>;
};

export default forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { id, options, onClearErrors, setInputFocus, onBlur, className, defaultValue, ...rest },
  ref
) {
  return (
    <div className={classNames(className, styles.container, rest.disabled ? styles.containerUneditable : null)}>
      <select
        ref={ref}
        id={id}
        className={styles.select}
        onClick={(e) => {
          e.preventDefault();
          onClearErrors?.();
        }}
        onFocus={() => {
          onClearErrors?.();
          setInputFocus?.(true);
        }}
        onBlur={(e) => {
          onBlur?.(e);
          setInputFocus?.(false);
        }}
        defaultValue={defaultValue}
        {...rest}
      >
        {options.map((option, index) => (
          <option key={`${option.label}-select-${index}`} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {rest.disabled ? (
        <Icon icon={IconUneditable} width={16} height={16} className={styles.icon} aria-hidden />
      ) : (
        <Icon icon={IconChevronDown} width={16} height={16} className={styles.icon} aria-hidden />
      )}
    </div>
  );
});
